'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["strValue"],
  _excluded2 = ["longValue"];
import * as DSAssetFamilies from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as DisplayTypes from 'customer-data-filters/filterQueryFormat/DisplayTypes';
import * as ListSegClassicAssetFamilies from './ListSegClassicAssetFamilies';
import * as OperationTypes from './OperationTypes';
import * as OperatorTypes from './ListSegClassicOperatorTypes';
import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import * as TimestampTypes from '../../filterQueryFormat/timestamps/TimestampTypes';
import { AdsEntityListTypes, PRIVACY_CONSENT, WistiaIntegrationFamilies, __ANY_CTA, __ANY_FORM, __ANY_LINK, __ANY_PAGE, __ANY_WEBINAR, __PRIVACY_CONSENT } from './ListSegConstants';
import { List, Map as ImmutableMap, OrderedMap, Seq } from 'immutable';
import { ListSegClassicTypeToDSAssetFamily } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilyMappings';
import { ListTypeToOperator } from './ListSegUtils';
import { convertTimestampToSimpleDate } from '../../filterQueryFormat/timestamps/TimestampConverters';
import { makeDynamicFilterFamily } from 'customer-data-filters/filterQueryFormat/DynamicFilterFamilies';
import { testDynamicFilterFamily } from '../../filterQueryFormat/DynamicFilterFamilies';
import And from '../../filterQueryFormat/logic/And';
import Any from 'customer-data-filters/filterQueryFormat/operator/Any';
import Constraint from '../../filterQueryFormat/logic/Constraint';
import ContainAll from 'customer-data-filters/filterQueryFormat/operator/ContainAll';
import ContainAllTeams from 'customer-data-filters/filterQueryFormat/operator/ContainAllTeams';
import DSFieldRecord from '../../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import Equal from 'customer-data-filters/filterQueryFormat/operator/Equal';
import Greater from 'customer-data-filters/filterQueryFormat/operator/Greater';
import GreaterOrEqual from 'customer-data-filters/filterQueryFormat/operator/GreaterOrEqual';
import GreaterThanRolling from 'customer-data-filters/filterQueryFormat/operator/GreaterThanRolling';
import I18n from 'I18n';
import InRange from 'customer-data-filters/filterQueryFormat/operator/InRange';
import Less from 'customer-data-filters/filterQueryFormat/operator/Less';
import LessOrEqual from 'customer-data-filters/filterQueryFormat/operator/LessOrEqual';
import LessThanRolling from 'customer-data-filters/filterQueryFormat/operator/LessThanRolling';
import MissingField from '../../filterQueryFormat/MissingField';
import Or from '../../filterQueryFormat/logic/Or';
import PrivacyConsentCompleted from '../../filterQueryFormat/operator/PrivacyConsentCompleted';
import PrivacyConsentNotCompleted from '../../filterQueryFormat/operator/PrivacyConsentNotCompleted';
import getIn from 'transmute/getIn';
import has from 'transmute/has';
import hasIn from 'transmute/hasIn';
import identity from 'transmute/identity';
import invariant from 'react-utils/invariant';
import isNumber from 'transmute/isNumber';
import isString from 'transmute/isString';
import partial from 'transmute/partial';
import Raven from 'raven-js';
export const BranchKeyByAssetFamily = {
  [ListSegClassicAssetFamilies.DEAL_PROPERTY]: 'dealsFilter',
  [ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY]: 'engagementsFilter',
  [ListSegClassicAssetFamilies.INTEGRATION]: 'integrationsTimelineFilter'
};
export const FilterLinesKeyByAssetFamily = {
  [ListSegClassicAssetFamilies.DEAL_PROPERTY]: 'filterLines',
  [ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY]: 'filters',
  [ListSegClassicAssetFamilies.INTEGRATION]: 'filterLines'
};
const parseOperator = entry => {
  const operator = entry.checkPastVersions ? `history_${entry.operator}` : entry.operator;
  if (operator === OperatorTypes.EQUAL && entry.type === OperationTypes.ENUMERATION) {
    Raven.capturePageEvent('ds-invalid-enum-operator-changed', {
      extra: {
        operator
      }
    });
    return OperatorTypes.IN;
  }
  if (operator === OperatorTypes.NOT_EQUAL && entry.type === OperationTypes.ENUMERATION) {
    Raven.capturePageEvent('ds-invalid-enum-operator-changed', {
      extra: {
        operator
      }
    });
    return OperatorTypes.NOT_IN;
  }
  if (operator === OperatorTypes.LESS_THAN_ROLLING && entry.reverseWithinTimeWindow) {
    return `${operator}_REVERSE`;
  }
  if (entry.compareProperty) {
    return `compare_${operator}`;
  }
  if (operator === OperatorTypes.EMAIL_EVENT) {
    const {
      emailEventEventFilterLines = []
    } = entry.emailEventFilter || {};
    if (emailEventEventFilterLines.length > 1) {
      const negativeLine = emailEventEventFilterLines[0].negated === true ? emailEventEventFilterLines[0] : emailEventEventFilterLines[1];
      const positiveLine = emailEventEventFilterLines[0].negated === true ? emailEventEventFilterLines[1] : emailEventEventFilterLines[0];
      return `${positiveLine.eventType}_NOT_${negativeLine.eventType}`;
    }
    return emailEventEventFilterLines[0].eventType;
  }
  if (entry.filterFamily === ListSegClassicAssetFamilies.EMAIL_SUBSCRIPTION) {
    return entry.subscriptionsFilter.optStatuses[0];
  }
  if (entry.type === OperationTypes.STRING && [OperatorTypes.EQUAL, OperatorTypes.NOT_EQUAL, OperatorTypes.EVER_EQUAL, OperatorTypes.NOT_EVER_EQUAL].includes(operator)) {
    return `${operator}_MULTI`;
  }
  if (operator.includes('PLACEMENT')) {
    return operator.replace('_PLACEMENT', '');
  }
  return operator;
};
const getEngagementValue = entry => {
  switch (entry.type) {
    case OperationTypes.INT:
    case OperationTypes.INTEGER:
      return entry.intValue;
    case OperationTypes.LONG:
    case OperationTypes.DATE:
    case OperationTypes.DATE_TIME:
      return entry.longValue;
    case OperationTypes.BOOLEAN:
      return entry.boolValue;
    default:
      return entry.strValue;
  }
};
function convertNullToString(value) {
  return value === null ? 'null' : value;
}
function convertStringToBool(value) {
  return typeof value === 'string' ? value === 'true' : value;
}
function convertFromCompareOperation(Operator, field, entry) {
  const {
    compareProperty
  } = entry;
  return Operator.of(field, compareProperty);
}
function convertFromRollingOperation(Operator, field, entry) {
  const {
    withinLastTime,
    withinLastTimeUnit
  } = entry;
  const withinTimeMode = entry.filterFamily === ListSegClassicAssetFamilies.INTEGRATION ? entry.withinLastTimeMode : entry.withinTimeMode;
  const direction = withinTimeMode === 'PAST' ? 'backward' : 'forward';
  return Operator.of(field, parseInt(withinLastTime, 10), direction, withinLastTimeUnit.toLowerCase());
}
function convertFromRangedOperation(Operator, field, entry) {
  const value = entry.filterFamily === ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY ? getEngagementValue(entry) : entry.value;
  const {
    highValue
  } = entry;
  return Operator.of(field, convertTimestampToSimpleDate(value, field.get('timestampType')), convertTimestampToSimpleDate(highValue, field.get('timestampType')));
}
function convertFromIn(Operator, field, entry) {
  if (Operator === ContainAll && field.get('name') === 'hs_all_accessible_team_ids') {
    Operator = ContainAllTeams;
  }
  const value = entry.filterFamily === ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY ? getEngagementValue(entry) : entry.value;
  const operatorValues = value && typeof value === 'string' ? List(value.split(';').map(convertNullToString)) : List();
  return Operator.of(field, operatorValues);
}
function convertFromEmailClickOperation(Operator, field, entry) {
  const filterLine = entry.emailEventFilter.emailEventEventFilterLines[0];
  const defaultLinkValue = __ANY_LINK;
  const resolvedField = MissingField.isMissingField(field) ? field : field.set('displayType', DisplayTypes.EnumerationDisplayType);
  return Operator.of(resolvedField, filterLine.clickUrlSubstring || defaultLinkValue);
}
function convertFromEmailSubscriptionOperation(Operator, field, entry) {
  const {
    subscriptionIds
  } = entry.subscriptionsFilter;
  return Operator.of(field, List(subscriptionIds.map(id => `${id}`)));
}
function convertFromAdsInteractionFilter(Operator, field, entry) {
  const {
    adsInteractionFilter: {
      entityList = []
    } = {}
  } = entry;
  return Operator.ofUnsafe(field, List(entityList), false);
}
function convertFromCtaOperation(Operator, field, entry) {
  const {
    operator,
    value
  } = entry;
  const isCta = operator === OperatorTypes.CTA_HAS_CLICKED || operator === OperatorTypes.CTA_NOT_HAS_CLICKED || operator === OperatorTypes.CTA_HAS_SEEN || operator === OperatorTypes.CTA_NOT_HAS_SEEN;
  const cta = isCta ? value : __ANY_CTA;
  return Operator.of(field, cta, isCta);
}
function convertFromFormOperator(Operator, field, entry) {
  const {
    page
  } = entry;
  const defaultPageValue = __ANY_PAGE;
  return Operator.of(field, page || defaultPageValue);
}
function convertFromImportOperator(Operator, field, entry) {
  const {
    importId
  } = entry;
  return Operator.of(field, `${ListSegClassicAssetFamilies.IMPORT}-${importId}`);
}
function convertFromWorkflowOperator(Operator, field, entry) {
  const {
    workflowId
  } = entry;
  return Operator.of(field, `${ListSegClassicAssetFamilies.WORKFLOW}-${workflowId}`);
}
function convertFromValueOperation(Operator, field, entry) {
  const value = entry.filterFamily === ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY ? getEngagementValue(entry) : entry.value;
  const safeValue = field.type === OperationTypes.BOOLEAN ? convertStringToBool(value) : convertNullToString(value);
  if (field.type === OperationTypes.DATE_TIME || field.type === OperationTypes.DATE) {
    return Operator.ofUnsafe(field, convertTimestampToSimpleDate(value, field.get('timestampType')));
  }
  if (field.type === OperationTypes.STRING && !MissingField.isMissingField(field)) {
    return convertFromIn(Operator, field, entry);
  }

  // HACK: Fix privacy consent values inline so they don't throw errors
  // https://git.hubteam.com/HubSpot/customer-data-filters/pull/501
  // This should be removed after a BE migration is run
  if ([PrivacyConsentCompleted, PrivacyConsentNotCompleted].includes(Operator)) {
    const adjustedPrivacyConsentValue = value === 'prviacy_consent_revoke' ? 'privacy_consent_revoke' : value;
    return Operator.ofUnsafe(field, adjustedPrivacyConsentValue);
  }
  return Operator.ofUnsafe(field, safeValue);
}
function convertFromSurveyMonkey(Operator, field, entry) {
  const {
    surveyMonkeyQuestionDetails: {
      surveyId,
      questionOperator
    } = {}
  } = entry;
  if (questionOperator) {
    // eslint-disable-next-line no-use-before-define
    const toOperator = convertFromListSegClassic.get(questionOperator);
    const InnerOperator = ListTypeToOperator.get(questionOperator);
    return toOperator(InnerOperator, field, entry);
  }
  return Operator.of(field, surveyId);
}
function convertFromIntegration(toOperator, Operator, field, entry) {
  if (isString(entry.strValue)) {
    const {
        strValue
      } = entry,
      newEntry = _objectWithoutPropertiesLoose(entry, _excluded);
    newEntry.value = strValue;
    return toOperator(Operator, field, newEntry);
  }
  if (isNumber(entry.longValue)) {
    const {
        longValue
      } = entry,
      newEntry = _objectWithoutPropertiesLoose(entry, _excluded2);
    newEntry.value = longValue;
    return toOperator(Operator, field, newEntry);
  }
  return toOperator(Operator, field, entry);
}
const convertFromListSegClassic = ImmutableMap({
  // Property
  [OperatorTypes.AFTER]: convertFromCompareOperation,
  [OperatorTypes.BEFORE]: convertFromCompareOperation,
  [OperatorTypes.BETWEEN]: convertFromRangedOperation,
  [OperatorTypes.CONTAIN]: convertFromIn,
  [OperatorTypes.CONTAIN_ALL]: convertFromIn,
  [OperatorTypes.ENDS_WITH]: convertFromIn,
  [OperatorTypes.EQUAL]: convertFromValueOperation,
  [OperatorTypes.EQUAL_ANY]: convertFromIn,
  [OperatorTypes.EQUAL_ALL]: convertFromIn,
  [OperatorTypes.EVER_CONTAINED_ALL]: convertFromIn,
  [OperatorTypes.EVER_CONTAINED_ANY]: convertFromIn,
  [OperatorTypes.EVER_EQUAL]: convertFromValueOperation,
  [OperatorTypes.EVER_EQUAL_ANY]: convertFromIn,
  [OperatorTypes.EVER_IN]: convertFromIn,
  [OperatorTypes.GREATER]: convertFromValueOperation,
  [OperatorTypes.GREATER_OR_EQUAL]: convertFromValueOperation,
  [OperatorTypes.GREATER_THAN_ROLLING]: convertFromRollingOperation,
  [OperatorTypes.IN]: convertFromIn,
  [OperatorTypes.KNOWN]: convertFromValueOperation,
  [OperatorTypes.LESS]: convertFromValueOperation,
  [OperatorTypes.LESS_OR_EQUAL]: convertFromValueOperation,
  [OperatorTypes.LESS_THAN_ROLLING]: convertFromRollingOperation,
  [OperatorTypes.NOT_BETWEEN]: convertFromRangedOperation,
  [OperatorTypes.NOT_CONTAIN]: convertFromIn,
  [OperatorTypes.NOT_CONTAIN_ALL]: convertFromIn,
  [OperatorTypes.NOT_EQUAL]: convertFromValueOperation,
  [OperatorTypes.NOT_EQUAL_ALL]: convertFromIn,
  [OperatorTypes.NOT_EQUAL_ANY]: convertFromIn,
  [OperatorTypes.NOT_EVER_CONTAINED_ANY]: convertFromIn,
  [OperatorTypes.NOT_EVER_CONTAINED_ALL]: convertFromIn,
  [OperatorTypes.NOT_EVER_EQUAL]: convertFromValueOperation,
  [OperatorTypes.NOT_EVER_EQUAL_ANY]: convertFromIn,
  [OperatorTypes.NOT_IN]: convertFromIn,
  [OperatorTypes.NOT_KNOWN]: convertFromValueOperation,
  [OperatorTypes.STARTS_WITH]: convertFromIn,
  // Privacy Consent (Pseudo Contact property field so it has different operators)
  [OperatorTypes.HAS_PRIVACY_CONSENT]: convertFromValueOperation,
  [OperatorTypes.HAS_NOT_PRIVACY_CONSENT]: convertFromValueOperation,
  // CTA
  [OperatorTypes.CTA_HAS_CLICKED]: convertFromCtaOperation,
  [OperatorTypes.CTA_NOT_HAS_CLICKED]: convertFromCtaOperation,
  [OperatorTypes.CTA_NOT_HAS_SEEN]: convertFromCtaOperation,
  [OperatorTypes.CTA_HAS_SEEN]: convertFromCtaOperation,
  // Email Campaign
  [OperatorTypes.EMAIL_BOUNCED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_CLICKED]: convertFromEmailClickOperation,
  [OperatorTypes.EMAIL_EVENT]: convertFromValueOperation,
  [OperatorTypes.EMAIL_MARKED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_OPENED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_OPENED_NOT_CLICKED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_OPENED_NOT_REPLIED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_RECEIVED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_RECEIVED_NOT_OPENED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_REPLIED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_SENT]: convertFromValueOperation,
  [OperatorTypes.EMAIL_SENT_NOT_CLICKED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_SENT_NOT_RECEIVED]: convertFromValueOperation,
  [OperatorTypes.EMAIL_UNSUBSCRIBED]: convertFromValueOperation,
  // Email Subscription
  [OperatorTypes.HAS_NOT_OPTED]: convertFromEmailSubscriptionOperation,
  [OperatorTypes.HAS_OPTED_IN]: convertFromEmailSubscriptionOperation,
  [OperatorTypes.HAS_OPTED_OUT]: convertFromEmailSubscriptionOperation,
  // Event
  [OperatorTypes.EVENT_HAS]: convertFromValueOperation,
  [OperatorTypes.EVENT_NOT_HAS]: convertFromValueOperation,
  // FormSubmission
  [OperatorTypes.FORM_FILLED_OUT]: convertFromFormOperator,
  [OperatorTypes.FORM_NOT_FILLED_OUT]: convertFromFormOperator,
  // Import
  [OperatorTypes.IN_IMPORT]: convertFromImportOperator,
  [OperatorTypes.NOT_IN_IMPORT]: convertFromImportOperator,
  // List
  [OperatorTypes.LIST_IN]: convertFromValueOperation,
  [OperatorTypes.LIST_NOT_IN]: convertFromValueOperation,
  // Page View
  [OperatorTypes.PAGEVIEW_CONTAINS]: convertFromValueOperation,
  [OperatorTypes.PAGEVIEW_EQUAL]: convertFromValueOperation,
  [OperatorTypes.PAGEVIEW_MATCHES]: convertFromValueOperation,
  [OperatorTypes.PAGEVIEW_NOT_CONTAINS]: convertFromValueOperation,
  [OperatorTypes.PAGEVIEW_NOT_EQUAL]: convertFromValueOperation,
  [OperatorTypes.PAGEVIEW_NOT_MATCHES]: convertFromValueOperation,
  // SurveyMonkey
  [OperatorTypes.SURVEY_ANSWERED]: convertFromSurveyMonkey,
  [OperatorTypes.SURVEY_NOT_RESPONDED]: convertFromSurveyMonkey,
  [OperatorTypes.SURVEY_RESPONDED]: convertFromSurveyMonkey,
  // Webinar
  [OperatorTypes.WEBINAR_ATTENDED]: convertFromValueOperation,
  [OperatorTypes.WEBINAR_NOT_ATTENDED]: convertFromValueOperation,
  [OperatorTypes.WEBINAR_NOT_REGISTERED]: convertFromValueOperation,
  [OperatorTypes.WEBINAR_REGISTERED]: convertFromValueOperation,
  // Workflow
  [OperatorTypes.WORKFLOW_ACTIVE]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_COMPLETED]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_ENROLLED]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_MET_GOAL]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_NOT_ACTIVE]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_NOT_COMPLETED]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_NOT_ENROLLED]: convertFromWorkflowOperator,
  [OperatorTypes.WORKFLOW_NOT_MET_GOAL]: convertFromWorkflowOperator
});
const getFieldKeyPath = (assetFamily, entry) => {
  let name;
  if (assetFamily === DSAssetFamilies.FORM) {
    name = entry.form || __ANY_FORM;
  } else if (entry.filterFamily === PRIVACY_CONSENT) {
    name = __PRIVACY_CONSENT;
  } else if (assetFamily === DSAssetFamilies.EMAIL_CAMPAIGN) {
    name = `${entry.emailEventFilter.emailId}`;
  } else if (assetFamily === DSAssetFamilies.ADS_PROPERTY) {
    const {
      adNetwork,
      adsInteractionEntity,
      adsEntityListType = ''
    } = entry.adsInteractionFilter;
    const suffix = adsEntityListType.slice(0, -1);
    name = `${adNetwork}_${adsInteractionEntity}_${suffix}`.toLowerCase();
    if (adsEntityListType === AdsEntityListTypes.AD_TYPE) {
      name = `${adNetwork}_ad_type`.toLowerCase();
    } else if (adsEntityListType === AdsEntityListTypes.TIMESTAMP) {
      name = 'ad_interaction_timestamp';
    }
  } else if (assetFamily === DSAssetFamilies.SURVEY_MONKEY_QUESTION || assetFamily === DSAssetFamilies.SURVEY_MONKEY_SURVEY) {
    const {
      colId = '',
      questionId,
      rowId = '',
      surveyId
    } = entry.surveyMonkeyQuestionDetails;
    name = questionId ? `${questionId}-${rowId}-${colId}` : surveyId;
    if (assetFamily === DSAssetFamilies.SURVEY_MONKEY_QUESTION && !questionId) {
      console.error('Encountered SurveyMonkeyQuestion condition with no questionId', entry);
    }
  } else if ([DSAssetFamilies.CTA, DSAssetFamilies.EVENT].includes(assetFamily)) {
    name = entry.value;
  } else if (assetFamily === DSAssetFamilies.CONTACT_IMPORT) {
    name = `${entry.importId}`;
  } else if (assetFamily === DSAssetFamilies.CONTACT_LIST) {
    name = `${entry.list}`;
  } else if (assetFamily === DSAssetFamilies.GOTO_WEBINAR_WEBINAR) {
    name = entry.value || __ANY_WEBINAR;
  } else if (assetFamily === DSAssetFamilies.WORKFLOW) {
    name = `${entry.workflowId}`;
  } else {
    name = entry.property;
  }
  return [assetFamily, name];
};
const getNoFieldOptionListSegField = (assetFamily, groupIndex, filterIndex, lineIndex, displayType = null) => DSFieldRecord({
  displayType,
  label: I18n.text(`customerDataFilters.DSAssetFamilyNames.${assetFamily.toUpperCase()}`),
  metadata: ImmutableMap({
    hasNoFieldOptions: true
  }),
  name: `${assetFamily}-${groupIndex}-${filterIndex}-${lineIndex}`,
  type: assetFamily
});
const getAssetFamily = (entry, integrationId) => {
  if (entry.filterFamily === ListSegClassicAssetFamilies.INTEGRATION) {
    return makeDynamicFilterFamily(DSAssetFamilies.INTEGRATION, integrationId);
  } else if (entry.filterFamily === ListSegClassicAssetFamilies.SURVEY_MONKEY) {
    // HACK: pseudo-filterFamily SURVEY_MONKEY_QUESTION
    return hasIn(['surveyMonkeyQuestionDetails', 'questionId'], entry) ? DSAssetFamilies.SURVEY_MONKEY_QUESTION : DSAssetFamilies.SURVEY_MONKEY_SURVEY;
  } else if (entry.filterFamily === ListSegClassicAssetFamilies.DEAL_PROPERTY) {
    if (entry.propertyObjectType === 'LINE_ITEM') {
      return DSAssetFamilies.LINE_ITEM_PROPERTY;
    } else if (entry.propertyObjectType === 'PRODUCT') {
      return DSAssetFamilies.PRODUCT_PROPERTY;
    }
  }
  return ListSegClassicTypeToDSAssetFamily.get(entry.filterFamily) || DSAssetFamilies.CONTACT_PROPERTY;
};
const getBranchKey = filterFamily => BranchKeyByAssetFamily[filterFamily];
const getFilterLinesKey = filterFamily => FilterLinesKeyByAssetFamily[filterFamily];
const getOccurrenceRefinement = field => {
  const {
    maxOccurrences,
    minOccurrences
  } = field;
  const refinementField = DSFieldRecord({
    displayType: DisplayTypes.CountDisplayType,
    refinement: true,
    type: PropertyTypes.NUMBER
  });
  if (maxOccurrences === undefined) {
    return Greater.of(refinementField, minOccurrences);
  } else if (minOccurrences === undefined) {
    return Less.of(refinementField, maxOccurrences);
  }
  return Equal.of(refinementField, minOccurrences || maxOccurrences);
};
const getBetweenRefinement = entry => {
  const {
    afterTimestamp,
    beforeTimestamp
  } = entry;
  const field = DSFieldRecord({
    refinement: true,
    timestampType: TimestampTypes.PORTAL_TZ_ALIGNED,
    type: PropertyTypes.DATE
  });
  return InRange.of(field, convertTimestampToSimpleDate(afterTimestamp, field.get('timestampType')), convertTimestampToSimpleDate(beforeTimestamp, field.get('timestampType')));
};
const getDateRefinement = entry => {
  const {
    afterTimestamp,
    beforeTimestamp,
    lastOccurrenceAfterTimestamp,
    firstOccurrenceBeforeTimestamp
  } = entry;
  const field = DSFieldRecord({
    refinement: true,
    timestampType: TimestampTypes.PORTAL_TZ_ALIGNED,
    type: PropertyTypes.DATE
  });
  if (lastOccurrenceAfterTimestamp !== undefined || afterTimestamp !== undefined) {
    return GreaterOrEqual.of(field, convertTimestampToSimpleDate(lastOccurrenceAfterTimestamp || afterTimestamp, field.get('timestampType')));
  }
  return LessOrEqual.of(field, convertTimestampToSimpleDate(firstOccurrenceBeforeTimestamp || beforeTimestamp, field.get('timestampType')));
};
const getRollingRefinement = entry => {
  const {
    reverseWithinTimeWindow,
    withinTimeMode,
    withinLastTime,
    withinLastTimeUnit
  } = entry;
  const field = DSFieldRecord({
    refinement: true,
    type: PropertyTypes.DATE
  });
  const direction = withinTimeMode === 'PAST' ? 'backward' : 'forward';
  if (reverseWithinTimeWindow) {
    return GreaterThanRolling.of(field, parseInt(withinLastTime, 10), direction, withinLastTimeUnit.toLowerCase());
  }
  return LessThanRolling.of(field, parseInt(withinLastTime, 10), direction, withinLastTimeUnit.toLowerCase());
};
const getEmailCampaignRefinement = entry => {
  const {
    absoluteEventDate,
    highAbsoluteEventDate,
    timeOperator
  } = entry;
  const field = DSFieldRecord({
    refinement: true,
    timestampType: TimestampTypes.PORTAL_TZ_ALIGNED,
    type: PropertyTypes.DATE
  });
  if (timeOperator === 'BETWEEN') {
    return InRange.of(field, convertTimestampToSimpleDate(absoluteEventDate, field.get('timestampType')), convertTimestampToSimpleDate(highAbsoluteEventDate, field.get('timestampType')));
  } else if (timeOperator === 'BEFORE') {
    return LessOrEqual.of(field, convertTimestampToSimpleDate(absoluteEventDate, field.get('timestampType')));
  } else if (timeOperator === 'AFTER') {
    return GreaterOrEqual.of(field, convertTimestampToSimpleDate(absoluteEventDate, field.get('timestampType')));
  }
  return undefined;
};
const getRefinement = entry => {
  if (entry.filterFamily === ListSegClassicAssetFamilies.EMAIL_CAMPAIGN) {
    return getEmailCampaignRefinement(entry.emailEventFilter.emailEventEventFilterLines[0]);
  }
  if (has('maxOccurrences', entry) || has('minOccurrences', entry)) {
    return getOccurrenceRefinement(entry);
  } else if (has('afterTimestamp', entry) && has('beforeTimestamp', entry)) {
    return getBetweenRefinement(entry);
  } else if (has('lastOccurrenceAfterTimestamp', entry) || has('firstOccurrenceBeforeTimestamp', entry) || has('afterTimestamp', entry) || has('beforeTimestamp', entry)) {
    return getDateRefinement(entry);
  } else if (has('withinLastTime', entry)) {
    return getRollingRefinement(entry);
  }
  return Any.of(DSFieldRecord({
    refinement: true,
    type: PropertyTypes.DATE
  }));
};
const fromPropertyFamily = (getField, entry, groupIndex, filterIndex, lineIndex, integrationId) => {
  const assetFamily = getAssetFamily(entry, integrationId);
  const parsedOperator = parseOperator(entry);
  const Operator = ListTypeToOperator.get(parsedOperator);
  invariant(Operator !== undefined, 'ListSegClassic operator `%s` is not defined in ListTypeToOperator', parsedOperator);
  const toOperator = convertFromListSegClassic.get(parsedOperator);
  invariant(typeof toOperator === 'function', 'no toOperator defined from `%s` to `%s` operator', parsedOperator, Operator.toString());
  let field;
  if (assetFamily === DSAssetFamilies.EMAIL_SUBSCRIPTION) {
    // TODO: refactor to remove this special case
    field = getNoFieldOptionListSegField(assetFamily, groupIndex, filterIndex, lineIndex, DisplayTypes.EmailSubscriptionDisplayType);
  } else {
    const fieldKeyPath = getFieldKeyPath(assetFamily, entry);
    field = getField(fieldKeyPath);
  }
  if (assetFamily === DSAssetFamilies.ADS_PROPERTY) {
    if (entry.adsInteractionFilter.adsEntityListType === AdsEntityListTypes.TIMESTAMP) {
      const effectiveEntry = Object.assign({}, (_objectDestructuringEmpty(entry), entry));
      if (entry.operator === OperatorTypes.LESS) {
        effectiveEntry.value = entry.beforeTimestamp;
        delete effectiveEntry.beforeTimestamp;
      } else if (entry.operator === OperatorTypes.GREATER) {
        effectiveEntry.value = entry.afterTimestamp;
        delete effectiveEntry.afterTimestamp;
      } else {
        effectiveEntry.highValue = entry.beforeTimestamp;
        effectiveEntry.value = entry.afterTimestamp;
        delete effectiveEntry.beforeTimestamp;
        delete effectiveEntry.afterTimestamp;
      }
      return toOperator(Operator, field, effectiveEntry);
    }
    let AdsInteractionOperator = Operator;
    if (Operator === ListTypeToOperator.get(OperatorTypes.IN) && entry.adsInteractionFilter.adsEntityListType === AdsEntityListTypes.NAMES) {
      AdsInteractionOperator = ListTypeToOperator.get(OperatorTypes.EQUAL_ANY);
    }
    return convertFromAdsInteractionFilter(AdsInteractionOperator, field, entry);
  }
  return testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily) ? convertFromIntegration(toOperator, Operator, field, entry) : toOperator(Operator, field, entry);
};
const fromRefinableFamily = (getField, entry, groupIndex, filterIndex, lineIndex) => {
  const assetFamily = getAssetFamily(entry);
  const parsedOperator = parseOperator(entry);
  const Operator = ListTypeToOperator.get(parsedOperator);
  invariant(Operator !== undefined, 'ListSegClassic operator `%s` is not defined in ListTypeToOperator', parsedOperator);
  const toOperator = convertFromListSegClassic.get(parsedOperator);
  invariant(typeof toOperator === 'function', 'no toOperator defined from `%s` to `%s` operator', parsedOperator, Operator.toString());
  let field;
  if (assetFamily === DSAssetFamilies.PAGE_VIEW) {
    // TODO: refactor to remove this special case
    field = getNoFieldOptionListSegField(assetFamily, groupIndex, filterIndex, lineIndex);
  } else {
    const fieldKeyPath = getFieldKeyPath(assetFamily, entry);
    if (entry.operator === OperatorTypes.CTA_HAS_CLICKED || entry.operator === OperatorTypes.CTA_NOT_HAS_CLICKED || entry.operator === OperatorTypes.CTA_HAS_SEEN || entry.operator === OperatorTypes.CTA_NOT_HAS_SEEN) {
      const innerFieldKeyPath = [DSAssetFamilies.CTA_TO_PLACEMENT, fieldKeyPath[1]];
      field = getField(innerFieldKeyPath);
    } else {
      field = getField(fieldKeyPath);
    }
  }
  const operator = toOperator(Operator, field, entry);
  const refinement = getRefinement(entry);
  return operator.set('refinement', refinement);
};
const getFilterField = filterFamily => {
  if (filterFamily === DSAssetFamilies.ENGAGEMENT_PROPERTY) {
    return identity;
  }
  return getIn(['filter']);
};
const convertEntry = (groupIndex, getField, entry, filterIndex, lineIndex = 0, integrationId) => {
  const assetFamily = getAssetFamily(entry, integrationId);

  // If no operator is provided then it's a filter branch so add an AND operator
  // and process the branch. In ListSegClassic only some families are branches.
  const entryBranchKey = getBranchKey(entry.filterFamily);
  const filterLinesKey = getFilterLinesKey(entry.filterFamily);
  const isMultilineOperator = !entry.operator || entry.dealsFilter || entry.engagementsFilter || entry.operator === OperatorTypes.INTEGRATION_OPERATOR && assetFamily !== DSAssetFamilies.EMAIL_SUBSCRIPTION;
  if (entryBranchKey && filterLinesKey && isMultilineOperator) {
    const entryLines = getIn([entryBranchKey, filterLinesKey], entry) || [];
    const eventTypeId = getIn([entryBranchKey, 'eventTypeId'], entry);
    return entryLines.reduce((acc, entryLine, index) => {
      const filter = getFilterField(assetFamily)(entryLine);
      return acc.mergeWith((oldVal, newVal) => oldVal.concat(newVal), convertEntry(groupIndex, getField, filter, filterIndex, index, eventTypeId));
    }, ImmutableMap());
  }
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
    return ImmutableMap({
      [assetFamily]: Seq([fromPropertyFamily(getField, entry, groupIndex, filterIndex, lineIndex, integrationId)])
    });
  }
  if (entry.filterFamily === PRIVACY_CONSENT) {
    return ImmutableMap({
      [assetFamily]: Seq([fromRefinableFamily(getField, entry, groupIndex, filterIndex, lineIndex)])
    });
  }
  switch (assetFamily) {
    case DSAssetFamilies.ADS_PROPERTY:
    case DSAssetFamilies.CONTACT_PROPERTY:
    case DSAssetFamilies.CONTACT_IMPORT:
    case DSAssetFamilies.CONTACT_LIST:
    case DSAssetFamilies.COMPANY_PROPERTY:
    case DSAssetFamilies.DEAL_PROPERTY:
    case DSAssetFamilies.EMAIL_SUBSCRIPTION:
    case DSAssetFamilies.ENGAGEMENT_PROPERTY:
    case DSAssetFamilies.GOTO_WEBINAR_WEBINAR:
    case DSAssetFamilies.LINE_ITEM_PROPERTY:
    case DSAssetFamilies.PRODUCT_PROPERTY:
    case DSAssetFamilies.SURVEY_MONKEY_QUESTION:
    case DSAssetFamilies.SURVEY_MONKEY_SURVEY:
    case DSAssetFamilies.WORKFLOW:
      return ImmutableMap({
        [assetFamily]: Seq([fromPropertyFamily(getField, entry, groupIndex, filterIndex, lineIndex, integrationId)])
      });
    case DSAssetFamilies.CTA:
    case DSAssetFamilies.EMAIL_CAMPAIGN:
    case DSAssetFamilies.EVENT:
    case DSAssetFamilies.FORM:
    case DSAssetFamilies.PAGE_VIEW:
      return ImmutableMap({
        [assetFamily]: Seq([fromRefinableFamily(getField, entry, groupIndex, filterIndex, lineIndex)])
      });
    default:
      throw new Error(`cannot convert filterType "${entry.filterFamily}" to filter query format`);
  }
};
const nestFilterFamilies = (getField, baseFilterFamily, andGroup, groupIndex) => {
  const convertedGroups = andGroup.reduce((acc, entry, filterIndex) => {
    const filters = convertEntry(groupIndex, getField, entry, filterIndex);

    // HACK: Wistia integrations are special and do not obey the same boolean
    // logic the rest of the filter families do so we can't nest them.
    // DO NOT replicate this workaround without talking to #crm-datasets
    // See: https://git.hubteam.com/HubSpot/customer-data-filters/pull/261
    const wistiaIntegrationFilters = filters.filter((_, family) => WistiaIntegrationFamilies.includes(family));
    const containsWistiaIntegration = !wistiaIntegrationFilters.isEmpty();
    const nestableFilters = containsWistiaIntegration ? filters.filter((_, family) => !WistiaIntegrationFamilies.includes(family)) : filters;
    if (containsWistiaIntegration) {
      wistiaIntegrationFilters.forEach((filter, family) => {
        acc = acc.update(family, (value = List()) => {
          return value.push(And.of(...filter.toArray()).set('filterFamily', family));
        });
      });
    }
    return acc.mergeWith((oldVal, newVal) => {
      return oldVal.concat(newVal);
    }, nestableFilters);
  }, OrderedMap());
  const andGroups = convertedGroups.reduce((acc, group, filterFamily) => {
    if (filterFamily === baseFilterFamily) {
      return acc.concat(group.toArray());
    }
    if (WistiaIntegrationFamilies.includes(filterFamily)) {
      return acc.concat(group.toArray());
    }
    acc.push(And.of(...group.toArray()).set('filterFamily', filterFamily));
    return acc;
  }, []);
  return And.of(...andGroups).set('filterFamily', baseFilterFamily);
};
const _getGetFieldFn = fields => keyPath => {
  const defaultField = MissingField({
    name: `${keyPath[keyPath.length - 1]}`,
    timestampType: TimestampTypes.NONE,
    type: PropertyTypes.STRING
  });
  const fullKeyPath = keyPath[0] === DSAssetFamilies.CTA_TO_PLACEMENT ? [DSAssetFamilies.CTA, getIn(keyPath, fields)] : keyPath;
  return getIn(fullKeyPath, fields) || defaultField;
};
export const fromListSegClassic = (fields, json, baseFilterFamily = undefined, constraint) => {
  // HACK: shim for CRM-Issues#955 transition
  const getField = typeof fields === 'function' ? fields : _getGetFieldFn(fields);
  if (!fields || !json) {
    return Or().set('filterFamily', baseFilterFamily);
  }
  const nestFilterFamiliesInAndGroup = partial(nestFilterFamilies, getField, baseFilterFamily);
  const andGroups = Seq(json).map(nestFilterFamiliesInAndGroup).map(Constraint.removeFromGroup(constraint));
  return Or.of(...andGroups).set('filterFamily', baseFilterFamily);
};